import { useOptimisticAddOngoingAssessmentAssignee } from '@/api/optimistic-add-ongoing-assessment-assignee.hook'
import { useOptimisticRemoveOngoingAssessmentAssignee } from '@/api/optimistic-remove-ongoing-assessment-assignee.hook'
import type { User } from '@/gen/customer/management/v1/service_pb'

import { useTrackCallback } from '@/lib/analytics/events'

import { useAssessmentAnalytics } from '@/pages/assessment/analytics'

import { AssigneeDisplay as SharedAssigneeDisplay } from '@/components/shared/assignee/assignee-display'

interface AssigneeDisplayProps {
  assignees: User[]
  popoverAlign?: 'start' | 'center' | 'end'
  ongoingAssessmentId: string
  companyId?: string
}

export const AssigneeDisplay = ({
  assignees,
  popoverAlign,
  ongoingAssessmentId,
  companyId,
}: AssigneeDisplayProps) => {
  const trackingContext = useAssessmentAnalytics()
  const trackAssigneeAddClick = useTrackCallback('third-party.assessment.assignee.add.click')
  const { mutateAsync: addAssignee } = useOptimisticAddOngoingAssessmentAssignee(companyId)
  const { mutateAsync: removeAssignee } = useOptimisticRemoveOngoingAssessmentAssignee(companyId)

  return (
    <SharedAssigneeDisplay
      assignees={assignees}
      popoverAlign={popoverAlign}
      onAssign={(userId) => addAssignee({ ongoingAssessmentId, userId })}
      onUnassign={(userId) => removeAssignee({ ongoingAssessmentId, userId })}
      onAddClick={() => {
        if (trackingContext) {
          trackAssigneeAddClick(trackingContext)
        }
      }}
    />
  )
}
